import { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import "../../../../styles/panel/user/manageShop/EditShopPages.css";

import { Icon, BACK_ICON } from "./shared/EditShopShared";

import { fetchPages } from "../../../../api/storeManagement/pages";

import {
  getStoreCategories,
  getStoreCollections,
} from "../../../../api/product_management/productApi";

import SectionEditor from "./tabs/SectionEditor";

export default function EditShopPages() {
  const { shopId } = useParams();
  const navigate = useNavigate();
  const onBack = () => navigate(-1);

  const [pages, setPages] = useState([]);

  const [activePageKey, setActivePageKey] = useState(null);

  const [loading, setLoading] = useState(true);

  /*
   * دسته‌بندی‌ها و ویترین‌های فروشگاه
   * یک‌بار برای کل صفحه گرفته می‌شوند و بین همه‌ی
   * SectionEditor های product_showcase به اشتراک گذاشته می‌شوند
   * (به‌جای اینکه هر کدوم جدا درخواست بزنند)
   */
  const [categories, setCategories] = useState([]);
  const [collections, setCollections] = useState([]);

  useEffect(() => {
    if (!shopId) return;

    const loadPages = async () => {
      try {
        setLoading(true);

        const res = await fetchPages(shopId);

        const data = res.data || [];

        const sortedPages = [...data].sort(
          (a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0),
        );

        setPages(sortedPages);

        if (sortedPages.length > 0) {
          setActivePageKey(sortedPages[0].page_key);
        } else {
          setActivePageKey(null);
        }
      } catch (err) {
        console.error("Error loading pages:", err);
      } finally {
        setLoading(false);
      }
    };

    loadPages();
  }, [shopId]);

  useEffect(() => {
    if (!shopId) return;

    const loadOptions = async () => {
      try {
        const [catRes, colRes] = await Promise.all([
          getStoreCategories(shopId),
          getStoreCollections(shopId),
        ]);

        setCategories(catRes.data || []);
        setCollections(colRes.data || []);
      } catch (err) {
        console.error("load categories/collections error:", err);
      }
    };

    loadOptions();
  }, [shopId]);

  const activePage = pages.find((page) => page.page_key === activePageKey);

  /*
   * سکشن‌های product_showcase_* که پشت سر هم قرار دارن
   * رو توی یه گروه (برای نمایش توی گرید سه‌ستونه) جمع می‌کنیم.
   */
  const groupSections = (sections) => {
    const groups = [];

    sections.forEach((section) => {
      const isShowcase = Boolean(
        section?.section_key?.startsWith("product_showcase"),
      );

      const lastGroup = groups[groups.length - 1];

      if (isShowcase && lastGroup?.type === "showcase") {
        lastGroup.items.push(section);
      } else if (isShowcase) {
        groups.push({ type: "showcase", items: [section] });
      } else {
        groups.push({ type: "single", items: [section] });
      }
    });

    return groups;
  };

  return (
    <div className="esp-wrap">
      {/* Header */}

      <div className="esp-head">
        <button className="esp-back-btn" onClick={onBack}>
          <Icon>{BACK_ICON}</Icon>
        </button>

        <div>
          <h1>ویرایش صفحات</h1>

          <p>محتوای صفحات فروشگاهت رو از اینجا مدیریت کن.</p>
        </div>
      </div>

      {/* Loading */}

      {loading && <div className="esp-loading">در حال دریافت صفحات...</div>}

      {/* No pages */}

      {!loading && pages.length === 0 && (
        <div className="esp-empty-page">
          هیچ صفحه‌ای برای این فروشگاه تعریف نشده است.
        </div>
      )}

      {/* Tabs */}

      {!loading && pages.length > 0 && (
        <>
          <div className="esp-tabs">
            {pages.map((page) => (
              <button
                key={page.page_id}
                className={`esp-tab${
                  activePageKey === page.page_key ? " esp-tab--active" : ""
                }`}
                onClick={() => setActivePageKey(page.page_key)}
              >
                {page.title}
              </button>
            ))}
          </div>

          {/* Page */}

          <div className="esp-panel">
            {activePage?.sections?.length > 0 ? (
              <div className="esp-sections">
                {groupSections(
                  [...activePage.sections].sort(
                    (a, b) =>
                      (a.sort_order ?? a.sort_order ?? 0) -
                      (b.sort_order ?? b.sort_order ?? 0),
                  ),
                ).map((group, groupIndex) =>
                  group.type === "showcase" ? (
                    <div
                      className="se-showcase-grid"
                      key={`showcase-group-${groupIndex}`}
                    >
                      {group.items.map((section, itemIndex) => (
                        <SectionEditor
                          key={section.section_id}
                          section={section}
                          categories={categories}
                          collections={collections}
                          showcaseOrder={itemIndex + 1}
                        />
                      ))}
                    </div>
                  ) : (
                    group.items.map((section) => (
                      <SectionEditor
                        key={section.section_id}
                        section={section}
                        categories={categories}
                        collections={collections}
                      />
                    ))
                  ),
                )}
              </div>
            ) : (
              <div className="esp-empty-page">این صفحه هنوز سکشنی ندارد.</div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
